export const MESSAGES = 'MESSAGES'

export const MESSAGES_LIST = `${MESSAGES}_LIST`
export const MESSAGE_DONE = `${MESSAGES}_DONE`
export const MESSAGES_COUNT = `${MESSAGES}_COUNT`
